// Main translation loader - loads synchronous translator first, then async
import './translation-sync.js';

console.log(
  'Translation system: Synchronous translator loaded, starting async loader...'
);

// Use document ready event to ensure DOM is loaded before starting async loading
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', loadAsyncTranslator);
} else {
  // Document already loaded, start immediately but on next tick
  setTimeout(loadAsyncTranslator, 1);
}

function loadAsyncTranslator() {
  console.log('Translation system: Starting async translator load...');

  import('./translation-async.js')
    .then(() => {
      console.log('Translation system: Async translator import completed');
    })
    .catch(error => {
      console.error(
        'Translation system: Failed to load async translator',
        error
      );
      console.error('Error details:', error);
    });
}

// Export the sync translator as default for webpack
export { default } from './translation-sync.js';
